import React from 'react';
import './Legal.css';

function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: December 2025</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using Trackable ("the app"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the app.</p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>Trackable is a health and fitness tracking application that allows you to:</p>
          <ul>
            <li>Track weight, nutrition, sleep, steps, and workouts</li>
            <li>Set and monitor fitness goals</li>
            <li>Receive AI-powered coaching insights</li>
            <li>Connect with friends through social features</li>
            <li>Sync with Apple Health (iOS)</li>
          </ul>
        </section>

        <section>
          <h2>3. Account Registration</h2>
          <p>To use Trackable, you must:</p>
          <ul>
            <li>Be at least 13 years old</li>
            <li>Provide accurate registration information</li>
            <li>Keep your password secure</li>
            <li>Notify us of any unauthorized account use</li>
          </ul>
        </section>

        <section>
          <h2>4. User Responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>Use the app only for lawful purposes</li>
            <li>Not share harmful, offensive, or inappropriate content</li>
            <li>Not attempt to hack, disrupt, or abuse the service</li>
            <li>Not impersonate others or create fake accounts</li>
            <li>Respect other users in social features</li>
          </ul>
        </section>

        <section>
          <h2>5. Health Disclaimer</h2>
          <div className="disclaimer-box">
            <p><strong>Important:</strong> Trackable is for informational and tracking purposes only. It is NOT a substitute for professional medical advice, diagnosis, or treatment.</p>
            <ul>
              <li>Always consult a healthcare provider before starting any diet or exercise program</li>
              <li>AI coaching suggestions are general guidance, not medical advice</li>
              <li>Do not ignore professional medical advice because of something in this app</li>
              <li>Seek immediate medical attention for any health emergencies</li>
            </ul>
          </div>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>The app, including its design, features, and content, is owned by Trackable. You may not copy, modify, or distribute any part of the app without permission.</p>
        </section>

        <section>
          <h2>7. User Content</h2>
          <p>You retain ownership of content you create (posts, photos, etc.). By posting, you grant us a license to display it within the app's social features. You can delete your content at any time.</p>
        </section>

        <section>
          <h2>8. Privacy</h2>
          <p>Your privacy is important to us. Please review our <a href="/privacy">Privacy Policy</a> to understand how we collect and use your data.</p>
        </section>

        <section>
          <h2>9. Termination</h2>
          <p>We may suspend or terminate your account if you violate these terms. You may delete your account at any time through Settings.</p>
        </section>

        <section>
          <h2>10. Limitation of Liability</h2>
          <p>Trackable is provided "as is" without warranties. We are not liable for:</p>
          <ul>
            <li>Any health outcomes from using the app</li>
            <li>Data loss (though we take precautions to prevent it)</li>
            <li>Service interruptions or technical issues</li>
            <li>Actions of other users</li>
          </ul>
        </section>

        <section>
          <h2>11. Changes to Terms</h2>
          <p>We may update these terms. Continued use after changes constitutes acceptance. We'll notify you of significant changes.</p>
        </section>

        <section>
          <h2>12. Contact</h2>
          <p>Questions? Email: <a href="mailto:support@trackable.fit">support@trackable.fit</a></p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
